<label class="email-phone-label" *ngIf="props.label">
    {{ props.label | htmlDecode }}
    <span class="required-color" *ngIf="props.required">*</span>
</label>
<ng-container #fieldComponent></ng-container>
